<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Typography" pageTitle="Typography" />
            <TypographyContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TypographyContent from '../Typography/TypographyContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TypographyPage',
    components: {
        MainHeader,
        PageTitle,
        TypographyContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>